export const initWechatFontFix = () => {
    // 微信小程序内嵌页面直接跳过
    if (window.__wxjs_environment === 'miniprogram')
        return;
    const reset = () => {
        if (typeof WeixinJSBridge !== 'undefined' && typeof WeixinJSBridge.invoke === 'function') {
            WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
            WeixinJSBridge.on('menu:setfont', () => {
                WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
            });
        }
    };
    if (typeof WeixinJSBridge === 'object' && WeixinJSBridge !== null) {
        reset();
    }
    else {
        document.addEventListener('WeixinJSBridgeReady', reset, false);
    }
    const forceReset = () => {
        setTimeout(reset, 300);
    };
    window.addEventListener('load', forceReset);
    if (document.readyState === 'complete') {
        forceReset();
    }
    else {
        document.addEventListener('DOMContentLoaded', forceReset);
    }
};
